import React, {useRef} from 'react';
import { Search, X } from 'lucide-react';
import { Input } from './ui/input';

type Props = {value: string; onChange: (value: string) => void; label: string; placeholder: string; prefix: string};
export const SearchField = ({value, onChange, label, placeholder, prefix}: Props) => {
  const input = useRef<HTMLInputElement>(null);
  return <div className="search-box">
    <Search size={16}/>
    <Input ref={input} data-testid={`${prefix}-input`} aria-label={label} value={value} onChange={event => onChange(event.target.value)} placeholder={placeholder}/>
    {value && <button type="button" className="icon-button" data-testid={`${prefix}-clear`} aria-label={`Clear ${label.toLowerCase()}`} title="Clear search" onClick={() => {onChange(''); input.current?.focus();}}><X size={14}/></button>}
  </div>;
};